module.exports = __webpack_public_path__ + "static/img/8114_phase_function_Paper_Points.a39ca64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8114_phase_function_Paper_Points.png
// module id = 7XTA
// module chunks = 0